import { Charts } from './Charts';
import PacientProfileChartsDataProvider from './contexts/PacientProfileChartsDataContext';

const PacientProfileWrapper = () => {
    return (
        <PacientProfileChartsDataProvider>
            <Charts />
        </PacientProfileChartsDataProvider>
    );
};

export default PacientProfileWrapper;
